/**
 * Shared helpers for the project-multiselect filter (K7).
 */
import { PROJECT_IDS_MAX } from '@aica/api-types';

/**
 * Stable TanStack Query key fragment for a project-id selection.
 *
 * `useQuery`'s key hashing is positional for arrays — `['a','b']` and
 * `['b','a']` are different cache slots even though they mean the same
 * filter. Sorting (and deduping, defensively) before it goes into a
 * queryKey collapses both onto the same slot, mirroring the backend's own
 * dashboard cache-key hash over the sorted list (edge-api cache-keys.ts).
 */
export function sortedProjectIdsKey(projectIds: string[]): string[] {
  return [...new Set(projectIds)].sort();
}

/**
 * The projects a report's link names (#1233, #1235): exactly the ones the
 * report counted — `[]` when it counted the whole organization (`null`).
 *
 * Undefined — the numbers stay plain — while they are not known, when there
 * are none (an empty membership: the report is empty, a list without a
 * project filter is not), or past the list filter's limit: a link that opens
 * a different number is worse than none.
 */
export function reportLinkProjectIds(
  counted: readonly string[] | null | undefined
): readonly string[] | undefined {
  if (counted === undefined) return undefined;
  if (counted === null) return [];
  if (counted.length === 0 || counted.length > PROJECT_IDS_MAX) return undefined;
  return counted;
}
